function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e1a46;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M55.88,200.29c7.59,9.29,15.9,15.41,29.35,15.41,12,0,25.2-5.15,25.2-17.6,0-12.25-12.24-15.43-24.46-18.12C64.2,175.1,45.6,170.45,45.6,146.72,45.6,124.49,67.13,113,88.42,113c16.14,0,31.05,6.13,38.89,20.79L111.4,144.29c-4.89-8.08-13-13.7-24.21-13.7-10.51,0-22.51,5.13-22.51,15.85,0,9.57,13.71,13.73,28.88,16.68C113.84,167,131,174.38,131,197.33c0,25.95-23,36-45.73,36-19.3,0-33.26-5.12-44.51-21.28Z",
  transform: "translate(-40.72 -42.55)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M138.31,115.91h19.07v16.65h.49C168.37,120.3,182.33,113,199,113c36,0,60.18,25.46,60.18,60.19,0,34.21-25.19,60.14-57.25,60.14-20.54,0-36.92-10.29-44-23.23h-.49v76.05H138.31ZM198,215.7c24.7,0,40.61-18.58,40.61-42.54S222.66,130.59,198,130.59s-40.58,18.57-40.58,42.57S173.27,215.7,198,215.7",
  transform: "translate(-40.72 -42.55)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M268.88,130.59c11.75-12,28.86-17.62,45.49-17.62,33.75,0,47.92,16.12,47.92,48.42v49.16a127.76,127.76,0,0,0,1.73,19.8H345.66c-1.2-5.13-1.2-12.21-1.2-17.1H344c-7.57,11.72-20.29,20.05-37.64,20.05-23.24,0-42.55-11.76-42.55-34,0-37.92,44-40.11,72.14-40.11h7.32v-3.42c0-16.64-10.49-25.19-28.37-25.19-12.22,0-25,4.15-34,12.48Zm55.28,44.73c-24.21,0-39.86,6.61-39.86,22,0,14.43,10.75,19.82,25.2,19.82,22,0,33.23-15.91,33.73-34.48v-7.35Z",
  transform: "translate(-40.72 -42.55)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M388.72,132.05H363.78V115.91h24.94V90.22c0-27.88,9.79-47.67,40.61-47.67,4.91,0,11,1,14.67,2.94l-2.7,17.1a39.52,39.52,0,0,0-13-2.44c-19.8,0-20.53,14.42-20.53,34.24v21.52h27.87v16.14H407.81v98.3H388.72Z",
  transform: "translate(-40.72 -42.55)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M442.27,130.59C454,118.6,471.14,113,487.75,113c33.77,0,47.93,16.12,47.93,48.42v49.16a129,129,0,0,0,1.72,19.8H519.08c-1.22-5.13-1.22-12.21-1.22-17.1h-.49c-7.6,11.72-20.3,20.05-37.66,20.05-23.23,0-42.58-11.76-42.58-34,0-37.92,44.05-40.11,72.15-40.11h7.35v-3.42c0-16.64-10.54-25.19-28.38-25.19-12.2,0-24.94,4.15-34,12.48Zm55.28,44.73c-24.2,0-39.84,6.61-39.84,22,0,14.43,10.73,19.82,25.18,19.82,22,0,33.26-15.9,33.74-34.48v-7.35Z",
  transform: "translate(-40.72 -42.55)"
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "547.31 126.18 506.23 73.36 531.18 73.36 561.48 114.44 590.1 73.36 613.34 73.36 573.98 126.18 621.18 187.8 595.97 187.8 559.8 138.4 524.09 187.8 500.37 187.8 547.31 126.18"
});

function SvgPurpleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 621.18 243.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleLogo);
export default __webpack_public_path__ + "static/media/purpleLogo.1d348063.svg";
export { ForwardRef as ReactComponent };